import { useStyles } from './executive-summary-link.style'
import { Link } from 'react-router-dom'
import { reportService } from './report.service'

export const ExecutiveSummaryLink = ({ report, pageMode }) => {
  const classes = useStyles()

  const executiveSummary = report.executiveSummary
  const id = executiveSummary && executiveSummary.id
  const version = executiveSummary && executiveSummary.version

  if (id) {
    return (
      <Link className={`${classes.link}`} to={reportService.buildPageRoute(report, id, version, pageMode)} data-qa="view-executive-summary-link">
        Executive Summary
      </Link>
    )
  } else {
    return null
  }
}
